// src/components/resources/tools/generators/EmailThread/email-thread-utils.ts
//
// Pure helpers for the Email Thread Generator, extracted from the former
// single-file component so they can be unit-tested in isolation.

import type { EmailClient, EmailMessage } from './types'

/**
 * Returns the avatar style classes for a given client and user.
 */
export function getAvatarStyle(client: EmailClient, isCurrentUser?: boolean): string {
  if (client === 'gmail') {
    // Gmail: light gray for others, blue for current user
    return isCurrentUser
      ? 'bg-blue-600 text-white'
      : 'bg-gray-200 text-gray-700'
  } else {
    // Outlook: light blue for others, dark blue for current user
    return isCurrentUser
      ? 'bg-blue-800 text-white'
      : 'bg-blue-100 text-blue-700'
  }
}

/**
 * Creates a new message template for the thread.
 */
export function createMessageTemplate(counter: number): EmailMessage {
  return {
    id: `message-${counter}`,
    sender: 'New Teammate',
    email: 'team@company.com',
    timestamp: new Date().toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }),
    content: 'Add your message copy here. Summarize feedback, approvals, or action items for the campaign team.',
  }
}
